import React from 'react'

import { Label } from './styles'

export function InputLabel({ text, variant, hasError, ...rest }) {
  return (
    <Label {...rest} hasError={hasError} variant={variant}>
      {text}
    </Label>
  )
}
